export default __webpack_public_path__ + "static/media/bg_device_active.4057de43.png";